import { useDispatch, useSelector } from "react-redux"
import { startFetch, startFetchPdf } from "../../services/fetch/startFetch";
import trasladosService from "../../services/trasladosService";
import { cleanSolicitudTraslados, cleanSolicitudesTraslados, cleanTipoDocSolicitudesTraslados, deleteTipoDocSolicitudesTraslados, getAccesorios, getCausasTraslados, getCodigosTraslados, getEstadosTraslados, getMotivosTraslados, getSectoresTraslados, getSolicitudTraslados, getSolicitudesTraslados, getTipoDocSolicitudesTraslados, getTipoPrestaciones, getTipoSolicitudesTraslados, getTiposTraslados, postTipoDocSolicitudesTraslados, putTipoDocSolicitudesTraslados, cleanTrackingSolicitud, getAllSolicitudesTomadas, getByUserSolicitudesTomadas, cambiarEstadoSolicitud, deleteSolicitudTomada, postSolicitudTomada, getTipoTracking, getTrackingSolicitud, getNotasTraslado, postNotaTraslado, putNotaTraslado, deleteNotaTraslado, deleteSolicitudEnCarga } from "../../reducers/traslados/trasladosActions";
import { getTiposDocu } from "../../actions/autorizaciones/Autorizaciones";
import { startAlerta } from "../../actions/ui/alertas";
import { TAMANO_IMAGENES } from "../../utils/constants";
import { fileSize } from "../../helpers/filesFunctions";
import { validarQueTengaAunqueSeaUnSoloPermiso, validarSoloUnPermiso } from "../../helpers/permisos";
import { TRASLADOS_PERMISOS } from "../../utils/permisos";

export const useTraslados = () => {
    const dispatch = useDispatch();
    const solicitud = useSelector(state => state.traslados.solicitud);
    const solicitudes = useSelector(state => state.traslados.solicitudes);

    const { permisos: permisosUser } = useSelector((state) => state.auth);

    return {
        clean: {
            solicitud: () => dispatch(cleanSolicitudTraslados()),
            solicitudes: () => dispatch(cleanSolicitudesTraslados()),
            tipoDocSolicitudes: () => dispatch(cleanTipoDocSolicitudesTraslados()),
            trackingSolicitud: () => dispatch(cleanTrackingSolicitud())
        },
        get: {
            autorizaciones: {
                tipoDocumentacion: () => dispatch(getTiposDocu()),
            },
            contratos: {
                efectores: (codNom, setEfectores) => {
                    dispatch(startFetch(
                        () => trasladosService.contratos.getEfectores(codNom),
                        (response) => {
                            setEfectores(response);
                        })
                    );
                },
                prestadores: (idEfectorFacturacion, setMedicos) => {
                    dispatch(startFetch(
                        () => trasladosService.contratos.getMedicos(idEfectorFacturacion),
                        (response) => {
                            setMedicos(response);
                        })
                    );
                },
                domiciliosMedico: (idMedico, setList) => {
                    dispatch(startFetch(
                        () => trasladosService.contratos.getDomiciliosMedico(idMedico),
                        (response) => {
                            setList(response);
                        })
                    );
                }
            },
            solicitud: (id, setOpenModal, idUsuario) => {
                dispatch(startFetch(
                    () => trasladosService.getSolicitud(id),
                    (response) => {
                        dispatch(getSolicitudTraslados(response));
                        if (setOpenModal) {
                            response.solicitudTrasladoTomada?.idUsuarioTomada === idUsuario || response.solicitudTrasladoTomada?.idUsuarioTomada === null
                            || response.solicitudTrasladoTomada?.idUsuarioTomada === undefined
                            ?
                                setOpenModal({
                                    open: true,
                                    fieldsDisabled: false,
                                    title: `Auditar Orden N° ${response.id}`,
                                })
                            :
                                setOpenModal({
                                    open: true,
                                    fieldsDisabled: true,
                                    title: `Ver Orden N° ${response.id}`,
                                })
                        }
                    })
                );
            },
            infoAfiliadoSolicitud: (idAfiliado) => {
                dispatch(startFetch(
                    () => trasladosService.getInfoAfiliadoSolicitud(idAfiliado),
                    (response) => {
                        dispatch(getSolicitudTraslados(response));
                    })
                );
            },
            solicitudes: (values) => {
                dispatch(startFetch(
                    () => trasladosService.getSolicitudes(values),
                    (response) => {
                        dispatch(getSolicitudesTraslados(response));
                    })
                );
            },
            tipoDocSolicitudes: () => {
                dispatch(startFetch(
                    () => trasladosService.getTipoDocSolicitudes(),
                    (response) => {
                        dispatch(getTipoDocSolicitudesTraslados(response));
                    })
                );
            },
            getAllSolicitudesTomadas: () => {
                dispatch(startFetch(
                    () => trasladosService.getAllSolicitudesTomadas(),
                    (response) => {
                        dispatch(getAllSolicitudesTomadas(response));
                    })
                );
            },
            getByUserSolicitudesTomadas: () => {
                dispatch(startFetch(
                    () => trasladosService.getByUserSolicitudesTomadas(),
                    (response) => {
                        dispatch(getByUserSolicitudesTomadas(response));
                    })
                );
            },
            getTrackingSolicitud: (idSolicitud) => {
                dispatch(startFetch(
                    () => trasladosService.getTrackingSolicitud(idSolicitud),
                    (response) => {
                        dispatch(getTrackingSolicitud(response));
                    })
                );
            },
            notasTraslado: (idTraslado) => {
                dispatch(startFetch(
                    () => trasladosService.getNotasTraslado(idTraslado),
                    (response) => {
                        dispatch(getNotasTraslado(response));
                    })
                );
            },
            files: {
                pdf: (values) => dispatch(startFetchPdf(() => trasladosService.files.getPdf(values))),
                pdfSolicitud: (idSolicitud) => dispatch(startFetchPdf(() => trasladosService.files.getPdfSolicitud(idSolicitud)))
            },
            dim: {
                tiposTraslados: () => {
                    dispatch(startFetch(
                        () => trasladosService.getTiposTraslados(),
                        (response) => {
                            dispatch(getTiposTraslados(response));
                        })
                    );
                },
                accesorios: () => {
                    dispatch(startFetch(
                        () => trasladosService.getAccesorios(),
                        (response) => {
                            dispatch(getAccesorios(response));
                        })
                    );
                },
                causasTraslados: () => {
                    dispatch(startFetch(
                        () => trasladosService.getCausasTraslados(),
                        (response) => {
                            dispatch(getCausasTraslados(response));
                        })
                    );
                },
                motivosTraslados: () => {
                    dispatch(startFetch(
                        () => trasladosService.getMotivosTraslados(),
                        (response) => {
                            dispatch(getMotivosTraslados(response));
                        })
                    );
                },
                sectoresTraslados: () => {
                    dispatch(startFetch(
                        () => trasladosService.getSectoresTraslados(),
                        (response) => {
                            dispatch(getSectoresTraslados(response));
                        })
                    );
                },
                tipoSolicitudes: () => {
                    dispatch(startFetch(
                        () => trasladosService.getTipoSolicitudes(),
                        (response) => {
                            dispatch(getTipoSolicitudesTraslados(response));
                        })
                    );
                },
                estados: () => {
                    dispatch(startFetch(
                        () => trasladosService.getEstados(),
                        (response) => {
                            dispatch(getEstadosTraslados(response));
                        })
                    );
                },
                codigos: () => {
                    dispatch(startFetch(
                        () => trasladosService.getCodigosTraslados(),
                        (response) => {
                            dispatch(getCodigosTraslados(response));
                        })
                    );
                },
                tipoPrestaciones: () => {
                    dispatch(startFetch(
                        () => trasladosService.getTipoPrestaciones(),
                        (response) => {
                            dispatch(getTipoPrestaciones(response));
                        })
                    );
                },
                tipoTracking: () => {
                    dispatch(startFetch(
                        () => trasladosService.getTipoTracking(),
                        (response) => {
                            dispatch(getTipoTracking(response));
                        })
                    );
                },
            },
        },
        post: {
            tipoDocSolicitudes: (values) => {
                dispatch(startFetch(
                    () => trasladosService.postTipoDocSolicitudes(values),
                    (response) => {
                        dispatch(postTipoDocSolicitudesTraslados(response));
                        dispatch(startAlerta(`Tipo Documentación Agregada`, 'success', 'Comando Exitoso'));
                    })
                );
            },
            solicitud: (values, setFormValues, handleNext, formValues) =>  {
                dispatch(startFetch(
                    () => trasladosService.postSolicitud(values),
                    (response) => {
                        setFormValues({
                            ...formValues,
                            id: response
                        })
                        dispatch(startAlerta(`Solicitud Agregada`, 'success', 'Comando Exitoso'));
                        handleNext();
                    })
                );
            },
            solicitudTomada: (idSolicitud) => {
                dispatch(startFetch(
                    () => trasladosService.postSolicitudTomada(idSolicitud),
                    (response) => {
                        dispatch(postSolicitudTomada(response))
                    })
                );
            },
            nota: (values, handleNext) =>  {
                dispatch(startFetch(
                    () => trasladosService.postNotaTraslado(values),
                    (nota) => {
                        dispatch(postNotaTraslado(nota))
                        dispatch(startAlerta(`Nota Agregada Correctamente`, 'success', 'Comando Exitoso'));
                        handleNext();
                    })
                );
            },
        },
        put: {
            afiliaciones: {
                contactoAfiliado: (values, handleNext, alert) => {
                    dispatch(startFetch(
                        () => trasladosService.afiliaciones.putContactoAfiliado(values),
                        () => {
                            if (handleNext) handleNext();
                            if(alert) dispatch(startAlerta(alert, 'success', 'Comando Exitoso'));
                        })
                    );
                }
            },
            tipoDocSolicitudes: (values) => {
                dispatch(startFetch(
                    () => trasladosService.putTipoDocSolicitudes(values),
                    (response) => {
                        dispatch(putTipoDocSolicitudesTraslados(response));
                        dispatch(startAlerta(`Tipo Documentación Modificada`, 'success', 'Comando Exitoso'));
                    })
                );
            },
            solicitud: (values, formValues, setFormValues, setSolicitudCopy, handleNext, alert = `Solicitud Modificada`) =>  {
                dispatch(startFetch(
                    () => trasladosService.putSolicitud(values),
                    () => {
                        const newValue = {
                            ...formValues,
                            ...values
                        };
                        setFormValues(newValue);
                        setSolicitudCopy(newValue);
                        dispatch(startAlerta(alert, 'success', 'Comando Exitoso'));
                        handleNext();
                    })
                );
            },
            solicitudModal: (values, alert) =>  {
                dispatch(startFetch(
                    () => trasladosService.putSolicitud(values),
                    () => {
                        dispatch(startAlerta(alert, 'success', 'Comando Exitoso'));
                    })
                );
            },
            afiliadoModal: (values, alert) =>  {
                dispatch(startFetch(
                    () => trasladosService.putSolicitud(values),
                    () => {
                        dispatch(startAlerta(alert, 'success', 'Comando Exitoso'));
                    })
                );
            },
            traslado: (values, resetStepper) =>  {
                dispatch(startFetch(
                    () => trasladosService.putSolicitud(values),
                    () => {
                        dispatch(startAlerta("Solicitud Traslado Confirmada", 'success', 'Comando Exitoso'));
                        resetStepper();
                    })
                );
            },
            cambiarEstadoSolicitud: (values) => {
                dispatch(startFetch(
                    () => trasladosService.cambiarEstadoSolicitud(values),
                    (response) => {
                        cambiarEstadoSolicitud(response)
                    })
                );
            },
            administrarSolicitud: (id, idEstado, alert, handleClose) => {
                dispatch(startFetch(
                    () => trasladosService.administracionSolicitud(id, idEstado),
                    () => {
                        dispatch(startAlerta(alert, 'success', 'Comando Exitoso'));
                        handleClose();
                    })
                );
            },
            nota: (values, handleNext) =>  {
                dispatch(startFetch(
                    () => trasladosService.putNotaTraslado(values),
                    (nota) => {
                        dispatch(putNotaTraslado(nota))
                        dispatch(startAlerta(`Nota Modificada Correctamente`, 'success', 'Comando Exitoso'));
                        handleNext();
                    })
                );
            },
        },
        remove: {
            tipoDocSolicitudes: (id) => {
                dispatch(startFetch(
                    () => trasladosService.deleteTipoDocSolicitudes(id),
                    () => {
                        dispatch(deleteTipoDocSolicitudesTraslados(id));
                        dispatch(startAlerta(`Tipo Documentación Eliminada`, 'success', 'Comando Exitoso'));
                    })
                );
            },
            documentacion: (id, setFormValues, formValues) => {
                dispatch(startFetch(
                    () => trasladosService.deleteDocumentacionSolicitud(id),
                    () => {
                        setFormValues({
                            ...formValues,
                            documentacion: formValues.documentacion.filter(x => x.id !== id)
                        })
                        dispatch(startAlerta(`Documentación Eliminada`, 'success', 'Comando Exitoso'));
                    })
                );
            },
            solicitudTomada: (idSolicitud) => {
                dispatch(startFetch(
                    () => trasladosService.deleteSolicitudTomada(idSolicitud),
                    () => {
                        dispatch(deleteSolicitudTomada(idSolicitud))
                        dispatch(startAlerta(`Solicitud Liberada`, 'success', 'Comando Exitoso'));
                    })
                );
            },
            nota: (idNota, handleNext) =>  {
                dispatch(startFetch(
                    () => trasladosService.deleteNotaTraslado(idNota),
                    () => {
                        dispatch(deleteNotaTraslado(idNota))
                        dispatch(startAlerta(`Nota Eliminada Correctamente`, 'success', 'Comando Exitoso'));
                        handleNext();
                    })
                );
            },
            solicitudEnCarga: (idSolicitud) => {
                dispatch(startFetch(
                    () => trasladosService.deleteSolicitudEnCarga(idSolicitud),
                    () => {
                        dispatch(deleteSolicitudEnCarga(idSolicitud))
                        dispatch(startAlerta(`Solicitud Eliminada`, 'success', 'Comando Exitoso'));
                    })
                );
            }
        },
        upload: {
            documentacionSolicitudes: (files, idTipoDoc, idSolicitud, setFormValues, formValues) => {
                if (files?.size <= TAMANO_IMAGENES.DOCUMENTACION_AFILIADOS) {
                    const formData = new FormData();
                    formData.append("files", files);
                    dispatch(startFetch(
                        () => trasladosService.uploadDocumentacionSolicitud(formData, idTipoDoc, idSolicitud),
                        (response) => {
                            setFormValues({
                                ...formValues,
                                documentacion: response
                            })
                            dispatch(
                                startAlerta(
                                    `Archivo Cargado Correctamente`,
                                    'success',
                                    'Comando Exitoso',
                                ),
                            )
                        })
                    );
                  } else {
                    dispatch(
                      startAlerta(
                        `El archivo no puede ser mayor a: ${fileSize(
                          TAMANO_IMAGENES.DOCUMENTACION_AFILIADOS
                        )} y el mismo tiene: ${fileSize(files?.size)}`,
                        "info"
                      )
                    );
                  }
            }
        },
        data: {
            solicitud,
            solicitudes,
            solicitudesTomadas: useSelector(state => state.traslados.solicitudesTomadas),
            solicitudesTomadasUsuario: useSelector(state => state.traslados.solicitudesTomadasUsuario),
            tipoDocSolicitudes: useSelector(state => state.traslados.tipoDocSolicitudes),
            trackingSolicitud: useSelector(state => state.traslados.trackingSolicitud),
            notasTraslado: useSelector(state => state.traslados.notasTraslado),
            autorizaciones: {
                tipoDocumentacion: useSelector(state => state.autorizaciones.tiposDocumentacion)
            },

            dim: {
                tiposTraslados: useSelector(state => state.traslados.tiposTraslados),
                accesorios: useSelector(state => state.traslados.accesorios),
                causasTraslados: useSelector(state => state.traslados.causasTraslados),
                motivosTraslados: useSelector(state => state.traslados.motivosTraslados),
                sectoresTraslados: useSelector(state => state.traslados.sectoresTraslados),
                tipoSolicitudes: useSelector(state => state.traslados.tipoSolicitudes),
                estados: useSelector(state => state.traslados.estados),
                codigos: useSelector(state => state.traslados.codigos),
                tipoPrestaciones: useSelector(state => state.traslados.tipoPrestaciones),
                tipoTracking: useSelector(state => state.traslados.tipoTracking),
            }
        },
        permisos: {
            menu: {
                main: validarQueTengaAunqueSeaUnSoloPermiso(
                    permisosUser, 
                    [
                        TRASLADOS_PERMISOS.GESTION_SOLICITUDES,
                        TRASLADOS_PERMISOS.CONFIGURACION,
                        TRASLADOS_PERMISOS.AUDITORIA,
                        TRASLADOS_PERMISOS.INGRESO_SOLICITUDES,
                    ]
                ),
                home: {
                    ...TRASLADOS_PERMISOS.INGRESO_SOLICITUDES,
                    ...TRASLADOS_PERMISOS.AUDITORIA
                },
                configuracion: validarQueTengaAunqueSeaUnSoloPermiso(
                    permisosUser, 
                    [
                        TRASLADOS_PERMISOS.CONFIGURACION,
                    ]
                ),
                gestion: TRASLADOS_PERMISOS.GESTION_SOLICITUDES,
            },
            home: {
                breadcrumb: {
                    ingreso: validarSoloUnPermiso(
                        permisosUser,
                        TRASLADOS_PERMISOS.INGRESO_SOLICITUDES.ADMINISTRACION
                    ),
                    auditoria: validarQueTengaAunqueSeaUnSoloPermiso(
                        permisosUser,
                        [
                            TRASLADOS_PERMISOS.AUDITORIA
                        ]
                    )
                },
                auditoria: {
                    consulta: validarSoloUnPermiso(
                        permisosUser,
                        TRASLADOS_PERMISOS.AUDITORIA.GESTION
                    ),
                    administracion: validarSoloUnPermiso(
                        permisosUser,
                        TRASLADOS_PERMISOS.AUDITORIA.ADMINISTRACION_GESTION
                    ),
                    auditoriaMedica: validarSoloUnPermiso(
                        permisosUser,
                        TRASLADOS_PERMISOS.AUDITORIA.AUDITORIA_MEDICA
                    )
                }
            },
            configuracion: {
                consulta: validarSoloUnPermiso(
                    permisosUser,
                    TRASLADOS_PERMISOS.CONFIGURACION.CONSULTA
                ),
                alta: validarSoloUnPermiso(
                    permisosUser,
                    TRASLADOS_PERMISOS.CONFIGURACION.ALTA
                ),
                modificar: validarSoloUnPermiso(
                    permisosUser,
                    TRASLADOS_PERMISOS.CONFIGURACION.MODIFICAR
                ),
                baja: validarSoloUnPermiso(
                    permisosUser,
                    TRASLADOS_PERMISOS.CONFIGURACION.BAJA
                ),
            }
        }
    }
}